var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-alert',{attrs:{"border":"bottom","color":"pink darken-1","dark":""}},[_vm._v(" 403 Forbiden! ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }